module.exports = __webpack_public_path__ + "static/media/odin-logo-filled.ab013459.png";